import { render, staticRenderFns } from "./IngredientList.vue?vue&type=template&id=605257a6&scoped=true&"
import script from "./IngredientList.vue?vue&type=script&lang=js&"
export * from "./IngredientList.vue?vue&type=script&lang=js&"
import style0 from "./IngredientList.vue?vue&type=style&index=0&id=605257a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605257a6",
  null
  
)

export default component.exports